import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { SentryErrorHandler } from './sentry-error-handler';

@Injectable({
  providedIn: 'root',
})
export class SentryErrorInterceptor implements HttpInterceptor {
  constructor(private sentryErrorHandler: SentryErrorHandler) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((response: any) => {
        if (response instanceof HttpErrorResponse) {
          this.sentryErrorHandler.handleHttpError(response, request);
        }

        return throwError(() => response);
      }),
    );
  }
}
